import React, { FC, useState } from 'react';
import { GetUserResponseProps } from 'api/types';
import { AuthContext } from './AuthContext';

interface AuthProviderProps {
  children: React.ReactNode;
}

export const AuthProvider: FC<AuthProviderProps> = ({ children }) => {
  const [user, setUser] = useState<GetUserResponseProps>({} as GetUserResponseProps);
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  return <AuthContext.Provider value={{ user, setUser, isLoggingOut, setIsLoggingOut }}>{children}</AuthContext.Provider>;
};
